import { useEffect, useState } from "react";

import { useMerchantApiMutation } from ".";
import { ISwAppApi } from "../interfaces-and-types";

export const useQuickSubmitFormHelper = (
  queryKey: keyof ISwAppApi,
  refreshView: () => void,
  mutationType: "POST" | "PUT" | "DELETE" = "DELETE",
  urlTransformParams?: { key: string; value: string }[] // all params to replace
) => {
  const [itemId, setItemId] = useState<string | null>(null);
  const [isItemDeleteLocked, setItemDeleteLocked] = useState(false);

  const isModalOpen = itemId !== null && itemId !== "";

  const openModal = (id: string, is_delete_locked: boolean) => {
    setItemId(id);
    setItemDeleteLocked(is_delete_locked);
  };

  const closeModal = () => setItemId(null);

  var merchantMutation = useMerchantApiMutation<null, null>(
    queryKey,
    [],
    {},
    (urlTemplate) =>
      urlTransformParams
        ? urlTransformParams.reduce(
            (acc, paramObject) =>
              acc.replace(paramObject.key, paramObject.value),
            urlTemplate
          )
        : urlTemplate.replace("id", itemId!)
  );

  const { isLoading, isSuccess, mutate } =
    mutationType === "POST"
      ? merchantMutation.usePostMutation
      : mutationType === "PUT"
      ? merchantMutation.usePutMutation
      : merchantMutation.useDeleteMutation;

  useEffect(() => {
    if (isSuccess) {
      refreshView && refreshView();
      closeModal();
    }
  }, [isSuccess]);

  return {
    isModalOpen,
    openModal,
    closeModal,

    isItemDeleteLocked,

    isLoading,
    isSuccess,
    mutate,
  };
};
